import * as React from 'react';
export const CHSvg = React.forwardRef(function CHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M12.5 9.5h-3v3h-3v-3h-3v-3h3v-3h3v3h3z',
      }),
    ),
  );
});
CHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CH = {
  category: 'flag',
  colorable: false,
  name: 'CH',
  svg: CHSvg,
};
